module.exports = __webpack_public_path__ + "img/icon_command_exit.b2fa1a4e.svg";